import { useRef } from "react";

function TableHead({ headerData }) {
  const tableRef = useRef(null);

  return (
    <thead className={`bg-gray-200`} ref={tableRef}>
      <tr
        className={`text-sm leading-6 font-bold text-left h-11`}
        style={{ position: "sticky", top: 0, zIndex: 1 }}
      >
        {headerData.map((item, index) => {
          return (
            <th
              key={index}
              scope="col"
              className={`text-black whitespace-nowrap py-[6px] font-medium px-6 relative`}
              style={{
                minWidth: "auto",
                // maxWidth: isNumberColumn || isImageColumn ? columnWidth : '50px',
              }}
            >
              {!item.checkboxAction && (
                <span className="mr-2">{item.label}</span>
              )}
            </th>
          );
        })}
      </tr>
    </thead>
  );
}

export default TableHead;
